import React from "react"
import classNames from "classnames"
import { SafeAreaView } from "@hg/layouts"

import { useTranslation } from "@/locales"

import styles from "./index.module.less"

interface IProps {
    className?: string
    style?: React.CSSProperties
    onClick?: () => void
}

const Exit: React.FC<IProps> = (props) => {
    const { className, style, onClick } = props

    const { t } = useTranslation()

    return (
        <SafeAreaView
            mode="margin"
            edges={["top", "right"]}
            className={classNames(styles.exit, className)}
            style={style}
            onClick={onClick}
        >
            <span>{t("exit")}</span>
        </SafeAreaView>
    )
}

export default Exit
